export const PRODUCT_FEATURE = 'product';